import { LANGUAGES } from '@/base/const/lang.const'

export const PRIVACY_POLICY_LINK = {
  [LANGUAGES.pl]: 'https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf',
  [LANGUAGES.it]:
    'https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/privacy-policy-della-societ-autopay-it.pdf',
  [LANGUAGES.es]: 'https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/poltica-de-privacidad-de-autopay-es.pdf',
  [LANGUAGES.en]: 'https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/privacy_policy.pdf',
}
